import React, { useState, useEffect } from 'react';

const Slogan = () => {
  const phrases = [
    'El Mejor precio de Contado',
    'Créditos Personales',
    'Envíos a todo el país',
  ];
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentPhrase = phrases[currentPhraseIndex];
    let typingSpeed = 100;

    if (isDeleting) {
      typingSpeed /= 2;
    }

    const handleTyping = () => {
      if (!isDeleting && displayedText.length < currentPhrase.length) {
        setDisplayedText(currentPhrase.slice(0, displayedText.length + 1));
      } else if (isDeleting && displayedText.length > 0) {
        setDisplayedText(currentPhrase.slice(0, displayedText.length - 1));
      } else if (!isDeleting && displayedText.length === currentPhrase.length) {
        setTimeout(() => setIsDeleting(true), 4000); // Pausa de 4 segundos al terminar de escribir
      } else if (isDeleting && displayedText.length === 0) {
        setIsDeleting(false);
        setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayedText, isDeleting, phrases, currentPhraseIndex]);

  return (
    <div>
      {displayedText}
    </div>
  );
};

export default Slogan;
